import { render, staticRenderFns } from "./UserTopic.vue?vue&type=template&id=c95884e4&scoped=true&"
import script from "./UserTopic.vue?vue&type=script&lang=js&"
export * from "./UserTopic.vue?vue&type=script&lang=js&"
import style0 from "./UserTopic.vue?vue&type=style&index=0&id=c95884e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95884e4",
  null
  
)

export default component.exports